import script from "./PanelMaxSizeInputs.vue?vue&type=script&setup=true&lang=js"
export * from "./PanelMaxSizeInputs.vue?vue&type=script&setup=true&lang=js"

import "./PanelMaxSizeInputs.vue?vue&type=style&index=0&id=909db466&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-909db466"]])

export default __exports__